var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocial03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.71885 12.5942C10.3778 12.5942 13.4739 7.90465 13.4739 3.83912C13.4739 3.70728 13.471 3.57252 13.4651 3.44068C14.0674 3.00512 14.5872 2.46562 15 1.84752C14.4391 2.09708 13.8435 2.26007 13.2337 2.33092C13.8758 1.94603 14.3566 1.34138 14.5869 0.629062C13.9828 0.987056 13.3222 1.23959 12.6334 1.37584C12.1693 0.882683 11.5556 0.556155 10.8873 0.44674C10.219 0.337324 9.53324 0.451114 8.93609 0.770518C8.33893 1.08992 7.86363 1.59715 7.58365 2.21378C7.30368 2.83041 7.23464 3.52209 7.38721 4.18189C6.16406 4.12051 4.96746 3.80277 3.87499 3.24927C2.78252 2.69577 1.81856 1.91886 1.04561 0.968906C0.65275 1.64623 0.532535 2.44774 0.709394 3.21051C0.886253 3.97329 1.34691 4.64011 1.99775 5.07545C1.50914 5.05994 1.03123 4.92838 0.603516 4.69166V4.72975C0.603078 5.44055 0.848811 6.12957 1.29894 6.67969C1.74908 7.2298 2.37583 7.60706 3.07266 7.74732C2.62003 7.87116 2.14499 7.88921 1.68428 7.80006C1.88091 8.41136 2.26348 8.94601 2.77861 9.32942C3.29373 9.71282 3.9157 9.92583 4.55771 9.93873C3.46777 10.7949 2.12136 11.2593 0.735352 11.2571C0.489554 11.2567 0.243999 11.2416 0 11.212C1.40804 12.1153 3.04596 12.5951 4.71885 12.5942Z",
    fill: "#333448"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial03);
export default __webpack_public_path__ + "static/media/social-03.b308e295a2adf7394acd3ee36687aaa7.svg";
export { ForwardRef as ReactComponent };